// Same icons as their base programs on Receipt: CE runs on Visa (OI), FPT on Mastercard (CC).
export const CE_PROGRAM_META = {
  all: { name: "All", iconType: null },
  ce: { name: "Compelling Evidence", iconType: "verifi" },
  fpt: { name: "First-Party Trust", iconType: "mastercard" }
}
